<template>
  <div style="position: relative">
    <VideoCallButton
      :disabled="isPhotoPanelOpen && !isTakingPhoto"
      :class="{ 'take-photo': isTakingPhoto, active: isPhotoPanelOpen }"
      icon="mdi-camera"
      @click="openPhoto" />
    <VideoCallButton v-if="isPhotoPanelOpen" class="photo-close-button" icon="mdi-close" @click="closePhoto" />
  </div>
</template>

<script>
import VideoCallButton from "@/components/Common/VideoCallButton.vue";
import { EventManager, Actions, ChangeSectionPayload } from "@events";
import { SectionList } from "@module-system";
import { PhotoPanelActions, PhotoPanelEvents } from "../helpers/photoPanelActions";
export default {
  name: "PhotoButton",
  components: {
    VideoCallButton,
  },
  props: {
    rtcId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isPhotoPanelOpen: false,
      isTakingPhoto: false,
    };
  },
  mounted() {
    const self = this;

    EventManager.getEventEmitter(this.rtcId).on(PhotoPanelEvents.PhotoPanelTakePhotoOn, () => {
      self.isTakingPhoto = true;
    });

    EventManager.getEventEmitter(this.rtcId).on(PhotoPanelEvents.PhotoPanelTakePhotoOff, () => {
      self.isTakingPhoto = false;
    });

    EventManager.getEventEmitter(this.rtcId).on(PhotoPanelEvents.PhotoTaken, () => {
      self.isTakingPhoto = false;
    });

    EventManager.getActionEmitter(this.rtcId).on(PhotoPanelActions.ClosePhotoPanel, () => {
      self.isPhotoPanelOpen = false;
      self.isTakingPhoto = false;
    });
  },
  methods: {
    openPhoto() {
      if (this.isPhotoPanelOpen) {
        if (this.isTakingPhoto) {
          EventManager.getActionEmitter(this.rtcId).emit(PhotoPanelActions.TakePhoto);
        }
        return;
      }
      EventManager.getActionEmitter(this.rtcId).emit(PhotoPanelActions.OpenTypeSelectionPanel);

      this.isPhotoPanelOpen = true;
      EventManager.getActionEmitter(this.rtcId).emit("hide-stackable-buttons");
    },
    closePhoto() {
      EventManager.getActionEmitter(this.rtcId).emit(PhotoPanelActions.ClosePhotoPanel);
    },
  },
};
</script>

<style scoped>
.photo-close-button {
  position: absolute;
  top: 0;
  left: 120%;
  margin: 0 !important;
}

.take-photo {
  background-color: green;
  color: white;
}
</style>
